import React from "react";

export default function Fairness() {
    return (
        <main className="max-w-4xl mx-auto px-4 py-8">
            <h2 className="text-2xl font-bold mb-6">Treating Customers Fairly</h2>

            <p className="mb-4">
                At Clayton Car Contracts, we take Treating Customers Fairly (TCF) very seriously.
            </p>
            <p className="mb-4">
                All firms regulated by the Financial Conduct Authority (FCA) must pay due
                regard to the interests of customers and as a consequence, TCF is an integral
                part of our culture and embedded across all areas of our business.
            </p>
            <p className="mb-4">
                The principles of TCF aim to raise standards, benefiting consumers and
                increasing confidence in the financial services industry.
            </p>
            <p className="mb-4">
                Our TCF policy is centred around FCA guidance to ensure we consistently deliver
                fair outcomes to customers. We take responsibility both as an organisation and
                as individuals to provide quality service based on openness and transparency.
            </p>

            <h3 className="text-xl font-semibold mt-6 mb-3">The Six FCA Outcomes</h3>
            <ol className="list-decimal ml-6 space-y-2">
                <li>
                    Consumers are confident they are dealing with firms where fair treatment is
                    central to the culture.
                </li>
                <li>
                    Products and services are designed to meet the needs of identified consumer
                    groups and targeted accordingly.
                </li>
                <li>
                    Consumers receive clear information and are kept appropriately informed before,
                    during, and after the sale.
                </li>
                <li>
                    Where advice is provided, it is suitable and takes account of consumer
                    circumstances.
                </li>
                <li>
                    Products perform as firms have led consumers to expect, and associated
                    services meet acceptable standards.
                </li>
                <li>
                    Consumers do not face unreasonable post-sale barriers to change product,
                    switch provider, submit a claim or make a complaint.
                </li>
            </ol>

            <h3 className="text-xl font-semibold mt-6 mb-3">What You Can Expect From Us</h3>
            <ul className="list-disc ml-6 space-y-2">
                <li>Clear, fair and transparent pricing</li>
                <li>Quality advice from our experienced sales team based on your needs and circumstances</li>
                <li>Clear, jargon-free product information with opportunity to ask questions</li>
                <li>After-sales support including contract reminders, product updates and advice</li>
                <li>A full complaints handling procedure</li>
            </ul>

            <h3 className="text-xl font-semibold mt-6 mb-3">How We Deliver This</h3>
            <ul className="list-disc ml-6 space-y-2">
                <li>Regularly reviewing FCA material</li>
                <li>Providing clear and jargon-free information across all services</li>
                <li>Conducting gap analysis to identify improvements</li>
                <li>Auditing telephone and electronic correspondence for quality assurance</li>
                <li>Collecting customer and staff feedback to measure progress</li>
            </ul>

            <h3 className="text-xl font-semibold mt-6 mb-3">If You Feel Unfairly Treated</h3>
            <p className="mb-4">
                A critical element of TCF is how we handle complaints. If you have a complaint
                about any aspect of our service, please contact us and we will investigate
                quickly.
            </p>
            <p className="mb-4">
                Call our Customer Services team on <strong>01785 716133</strong> or email{" "}
                <a
                    href="mailto:claytoncontracts@gmail.com"
                    className="text-blue-600 underline"
                >
                    claytoncontracts@gmail.com
                </a>.
            </p>
            <p>Full details of our complaints procedure are available on request.</p>
        </main>
    );
}
